import { buildMetricSeries } from '@components/metrics-panel-hz/utils/metricSeriesOption';
import { getMetricMetaByKey } from '@src/utils/metrics';
import { usageMetricList } from '../atoms/index';
import { chartOption, utcMoment } from '../utils';

export const transformDataForChart = ({ metrics, data, totals }) => {
  const result = {};
  const allMetrics = getUsageMetricsMeta();
  metrics.forEach((m) => (result[m] = []));

  data.forEach((dataPoint) => {
    metrics.forEach((metric) => {
      let value = dataPoint.results[metric];
      const unit = allMetrics[metric].unit;
      if (unit === 'mins') {
        value = value / 60;
      }
      result[metric].push([dataPoint.timestamp, value]);
    });
  });
  // convert from mins to hours
  metrics.forEach((metric) => {
    const unit = allMetrics[metric].unit;
    if (!totals[metric]) totals[metric] = null;
    if (unit === 'mins' && totals[metric]) {
      totals[metric] = totals[metric] / 60;
    }
  });
  return { data: result, totals };
};

export function buildSeriesData({ instance, data, allMetrics, metric }) {
  allMetrics[metric].unit = '';
  let option = instance.getOption();
  if (option) {
    if (option._viewType !== 'timeseries') {
      const metricChartOption = chartOption(metric.metricName);
      instance.setOption(metricChartOption, { notMerge: true });
      option = instance.getOption();
    }
    const { series, xAxis, yAxis, tooltip } = formatSeries({
      option,
      data,
      metric,
      params: { filterColor: '#0f93f5' },
      allMetrics,
    });
    instance.setOption({ series, xAxis, yAxis, tooltip });
  }
}

export function formatSeries({ option, data = [], metric, params, allMetrics }) {
  // add or update metric filter series
  const { metricChartData, xAxis, yAxis, tooltip } = buildMetricSeries({
    option,
    data,
    metric,
    params,
    allMetrics,
    moment: utcMoment,
  });

  return { series: [metricChartData], xAxis, yAxis, tooltip };
}

export const getUsageMetricsMeta = () => {
  Object.keys(usageMetricList).forEach((key) => {
    const metricMeta = getMetricMetaByKey({
      metricKey: key,
      context: usageMetricList[key].product,
    });
    usageMetricList[key] = { ...metricMeta, ...usageMetricList[key] };
  });
  return usageMetricList;
};
